'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports.default = warn;